import { NgModule } from "@angular/core";
import { RouterModule as AngularRouterModule, Routes } from "@angular/router";

import { UserModule } from "../user/user.module";
import { RegistrationModule } from "../registration/registration.module";
import { RegistrationSimpleModule } from "@app/registration-simple/registration-simple.module";
import { BMEnvironmentGuard } from "@app/user/user-core/guardians/BM-environment.guard";
import { HelpModule } from "@app/user/customization/help/help.module";
import { MnsModule } from "@app/mns/mns.module";
import { CTTEnvironmentGuard } from "@app/user/user-core/guardians/CTT-environmnet.guard";
import { RegistrationEnvironmentGuard } from "@app/user/user-core/guardians/registration-environment.guard";
import { ExternalSourceDocumentOpenGuard } from "@app/user/user-core/guardians/external-source-document-open.guard";

const appRoutes: Routes = [
	{
		path: "user",
		loadChildren: (): Promise<UserModule> => import("../user/user.module").then((e): UserModule => e.UserModule)
	},
	{
		path: "user/open",
		canActivate: [ExternalSourceDocumentOpenGuard]
	},
	{
		path: "gov",
		loadChildren: (): Promise<MnsModule> => import("../mns/mns.module").then((e): MnsModule => e.MnsModule)
	},
	{
		path: "registration-simple",
		canActivate: [BMEnvironmentGuard],
		loadChildren: (): Promise<RegistrationSimpleModule> => import("../registration-simple/registration-simple.module").then((e): RegistrationSimpleModule => e.RegistrationSimpleModule)
	},
	{
		path: "registration",
		canActivate: [RegistrationEnvironmentGuard],
		loadChildren: (): Promise<RegistrationModule> => import("../registration/registration.module").then((e): RegistrationModule => e.RegistrationModule)
	},
	{
		path: "user/help",
		loadChildren: (): Promise<HelpModule> => import("../user/customization/help/help.module").then((e): HelpModule => e.HelpModule)
	},
	{
		path: "",
		redirectTo: "user/documents",
		pathMatch: "full"
	}
];

@NgModule({
	exports: [AngularRouterModule],
	imports: [AngularRouterModule.forRoot(appRoutes)],
	providers: [BMEnvironmentGuard, CTTEnvironmentGuard, RegistrationEnvironmentGuard]
})
export class RouterModule { }
